let activeRequests = 0;

export function showLoading() {
    activeRequests++;
    document.getElementById('global-loading')?.classList.remove('hide');
}

export function hideLoading() {
    activeRequests = Math.max(0, activeRequests - 1); // evita valores negativos
    if (activeRequests === 0) {
        document.getElementById('global-loading')?.classList.add('hide');
    }
}